<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <xrd-confirm-dialog
    title="tlsCertificates.managementService.generateKey.title"
    save-button-text="action.confirm"
    :show-close="false"
    :loading="loading"
    focus-on-accept
    @accept="generate"
    @cancel="cancel"
  >
    <template #text>
      <p data-test="generate-tls-and-certificate-dialog-explanation-text">
        {{ $t('tlsCertificates.managementService.generateKey.explanation') }}
      </p>
      <p data-test="generate-tls-and-certificate-dialog-confirmation-text">
        {{ $t('tlsCertificates.managementService.generateKey.confirmation') }}
      </p>
    </template>
  </xrd-confirm-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapStores } from 'pinia';
import { useNotifications } from '@/store/modules/notifications';
import { useManagementServices } from '@/store/modules/management-services';
import { XrdConfirmDialog } from '@niis/shared-ui';

export default defineComponent({
  components: { XrdConfirmDialog },
  emits: ['cancel', 'accept'],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapStores(useManagementServices),
  },
  methods: {
    ...mapActions(useNotifications, ['showError', 'showSuccess']),
    generate() {
      this.managementServicesStore
        .generateKey()
        .then(() => {
          this.showSuccess(
            this.$t('tlsCertificates.managementService.generateKey.success'),
          );
          this.$emit('accept');
        })
        .catch((error) => {
          this.showError(error);
          this.$emit('cancel');
        })
        .finally(() => (this.loading = false));
    },
    cancel(): void {
      this.$emit('cancel');
    },
  },
});
</script>

<style lang="scss" scoped>
p {
  margin-top: 30px;
}
</style>
